import { Stack } from "@mui/material";
import { IgBasePrimitives } from "@intelligems/ig-design-tokens";
import { IgChip, IgDialog, IgTypography } from "@intelligems/ig-theme";

export type SmartPricingKickoffVariant =
  | "addPriceTesting"
  | "startPriceTesting";

const KICKOFF_COPY: Record<
  SmartPricingKickoffVariant,
  { body: string; secondaryLabel: string; title: string }
> = {
  addPriceTesting: {
    body: "Smart Pricing setup involves a kickoff with a pricing specialist plus a few days of price tagging on your store.",
    secondaryLabel: "Add Smart Pricing",
    title: "Ready to add price testing?",
  },
  startPriceTesting: {
    body: "Smart Pricing setup involves a kickoff with your onboarding manager plus a few days of price tagging on your store.",
    secondaryLabel: "Do it later",
    title: "Ready to start price testing?",
  },
};

type SmartPricingKickoffDialogProps = {
  open: boolean;
  variant: SmartPricingKickoffVariant;
  onClose: () => void;
  onSecondaryAction: () => void;
  onConsultSpecialist: () => void;
};

export const SmartPricingKickoffDialog = ({
  open,
  variant,
  onClose,
  onSecondaryAction,
  onConsultSpecialist,
}: SmartPricingKickoffDialogProps) => {
  const { body, secondaryLabel, title } = KICKOFF_COPY[variant];

  return (
    <IgDialog
      showDialog={open}
      title={null}
      showCloseIcon
      shouldNotClose
      handleClose={onClose}
      minWidth="576px"
      sx={{ "& .MuiDialogActions-root": { marginTop: 0 } }}
      dontUseDialogContent
      rawContent={
        <Stack
          alignItems="center"
          gap={4}
          textAlign="center"
          // clears the absolutely-positioned close icon
          sx={{ pt: 7 }}
        >
          <IgChip
            color="secondary"
            label="Smart Pricing"
            sx={{
              backgroundColor: IgBasePrimitives[50],
              borderColor: IgBasePrimitives[50],
              color: IgBasePrimitives[500],
              fontSize: "10px",
              fontWeight: 700,
              letterSpacing: "0.5px",
              p: "4px 10px",
              textTransform: "uppercase",
            }}
          />
          <IgTypography color="primary" variant="h1" fontWeight={600}>
            {title}
          </IgTypography>
          <IgTypography color="textSecondary" fontSize="16px" lineHeight="150%">
            {body}
          </IgTypography>
        </Stack>
      }
      buttonVariant="outlined"
      noButtonText={secondaryLabel}
      handleNoClick={onSecondaryAction}
      yesButtonText="Consult pricing specialist"
      handleYesClick={onConsultSpecialist}
    />
  );
};
